import { useNavigate } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  className?: string;
}

export default function Logo({
  size = 'md',
  onClick,
  className = '',
}: LogoProps) {
  const navigate = useNavigate();

  const imgSize = size === 'sm' ? 'h-10' : size === 'lg' ? 'h-16' : 'h-14';

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate('/home');
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`cursor-pointer ${className}`}
    >
      <img
        src="https://public.readdy.ai/ai/img_res/3dc270e4-5b61-4676-ac46-8193427c09c6.png"
        alt="CJJY"
        className={`${imgSize} w-auto object-contain flex-shrink-0`}
      />
    </button>
  );
}